import Vue from 'vue'
import Vuex from 'vuex'
import { login, getUserInfo, loginByPhoneCode } from './api/api'

Vue.use(Vuex)

const ROLE_LIST = ['admin', 'producer', 'vip', 'finance']

import { asyncRouterMap, constantRouterMap } from './router/router'

/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permission
 * @param route
 * @returns {boolean}
 */
function hasPermission(role, route) {
  if (route.meta && route.meta.permission) {
    if (route.meta.permission.includes(role)) {
      return true
    } else {
      return false
    }
  }
  return true
}


function filterAsyncRouter(routerMap, role) {
  const accessedRouters = routerMap.filter(route => {
    if (hasPermission(role, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, role)
      }
      return true
    }
    return false
  })
  return accessedRouters
}


export default new Vuex.Store({
  state: {
    token: '',
    userName: '',
    userType: '',
    role: '',
    routers: constantRouterMap,
    addRouters: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },

    SET_USERNAME: (state, userName) => {
      state.userName = userName
    },


    SET_USERTYPE: (state, userType) => {
      state.userType = userType
    },

    SET_ROLE: (state, role) => {
      state.role = role
    },

    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },

  actions: {

    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo.userName, userInfo.password).then(res => {
          const { error, response } = res
          if (error.code === 0) {//登录成功
            commit('SET_TOKEN', response.token)
            Vue.ls.set('token', response.token, 1 * 24 * 60 * 60 * 1000)
            resolve()
          } else {//登录错误
            reject()
          }
        }).catch(error => {
          reject()
        })
      })
    },

    phoneLogin({ commit }, phoneInfo) {
      return new Promise((resolve, reject) => {
        loginByPhoneCode(phoneInfo).then(({ error, response }) => {
          if (error.code === 0) {//登录成功
            commit('SET_TOKEN', response.token)
            Vue.ls.set('token', response.token, 1 * 24 * 60 * 60 * 1000)
            resolve()
          } else {//登录错误
            reject()
          }
        }).catch(error => {
          reject()
        })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          const { error, response } = res
          if (error.code === 0) {
            commit('SET_TOKEN', Vue.ls.get('token'))
            commit('SET_USERNAME', response.username)
            commit('SET_USERTYPE', response.usertype)
            commit('SET_ROLE', ROLE_LIST[response.usertype])
            resolve()
          } else {//错误
            reject()
          }

        }).catch(error => {
          reject(error)
        })
      })
    },


    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        Vue.ls.remove('token')
        commit('SET_TOKEN', '')
        commit('SET_USERNAME', '')
        commit('SET_USERTYPE', '')
        commit('SET_ROLE', '')
        resolve()
      })
    },


    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { role } = data

        console.log(role)
        const accessedRouters = filterAsyncRouter(asyncRouterMap, role)

        console.log(accessedRouters)
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    },
  },

  getters: {
    token: state => state.token,
    userName: state => state.userName,
    userType: state => state.userType,
    role: state => state.role,
    addRouters: state => state.addRouters,
  }
})